module.exports = __webpack_public_path__ + "img/prestige-about-active@3x.png";